import { Logo } from "@areahub/icons";
import {
  Box,
  Modal as ChakraModal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  ModalProps,
} from "@chakra-ui/react";
import { PropsWithChildren } from "react";

export interface Modal_T
  extends Omit<ModalProps, "children">,
    PropsWithChildren {}

export const Modal = (props: Modal_T) => {
  const { children, ...rest } = props;

  return (
    <ChakraModal isCentered size="3xl" {...rest}>
      <ModalOverlay />
      <ModalContent borderRadius="16px">
        <ModalBody
          display="flex"
          borderRadius="16px"
          bg="white"
          flexDirection="column"
          alignItems="center"
          textAlign="center"
          position="relative"
          gap="50px"
          p="50px"
        >
          <ModalCloseButton
            _focusVisible={{
              outline: "none",
              boxShadow: "none",
            }}
          />
          <Box as={Logo} minW="200px" w="30%" />
          {children}
        </ModalBody>
      </ModalContent>
    </ChakraModal>
  );
};
